import { LoadableInterface } from 'shared/types/loadableInterface';
import { makeAutoObservable, reaction } from 'mobx';
import { ExplorerEntityTypes } from 'entities/types';
import {
  ExplorerStore,
  SomeEntity,
} from 'app/store/lib/explorers/explorerStore';
import { SectionModel } from 'entities/section/model/sectionModel';
import { RootStore } from 'app/store/rootStore';

export class TrashExplorerStore implements LoadableInterface {
  private _rootStore: RootStore;
  private _explorerStore: ExplorerStore;

  constructor({ rootStore }: { rootStore: RootStore }) {
    this._rootStore = rootStore;
    this._explorerStore = new ExplorerStore({
      rootStore,
      isDisableReaction: true,
    });
    makeAutoObservable(this);

    reaction(
      () => this.isPending,
      (isPending) => {
        this._rootStore.stateStore.isTrashExplorerLoading = isPending;
      }
    );
  }

  public get isPending() {
    return this._explorerStore.isPending;
  }

  public get isError() {
    return this._explorerStore.isError;
  }

  public get currentEntity(): SomeEntity | null {
    return this._explorerStore._currentEntity;
  }

  public setCurrentEntity(id: string | null, type: ExplorerEntityTypes | null) {
    this._explorerStore.setCurrentEntity(id, type);
  }
}
